export default __webpack_public_path__ + "static/media/nectavida-test-white.f706086e.svg";